const { getAdaRoot } = require('./elements');

let adaReady = false;
const adaReadyCallbacks = [];

const onAdaReady = (callback) => {
  if (typeof callback === 'function') adaReadyCallbacks.push(callback);
  if (!window || !window.adaEmbed) return false;

  while (adaReadyCallbacks.length) {
    const adaReadyCallback = adaReadyCallbacks.shift();
    adaReadyCallback(window.adaEmbed);
  }
  
  adaReady = true;

  return true;
};

const isAdaReady = () => adaReady;

const setVisible = (visibility = true) => {
  const adaRoot = getAdaRoot();
  if (!adaRoot) return false;

  if (visibility) adaRoot.classList.add('ada-chatbot-visible');
  else adaRoot.classList.remove('ada-chatbot-visible');

  return true;
};

const setZIndex = (zIndex) => {
  const adaRoot = getAdaRoot();
  if (!adaRoot) return false;

  adaRoot.style.zIndex = zIndex;

  return true;
};

module.exports = {
  onAdaReady,
  isAdaReady,
  setVisible,
  setZIndex,
};
